export enum ECheckoutPageEvent {
    BACK_TO_STORE = 'backToStore',
    BACK_TO_GAME = 'backToGame',
    SUPPORT = 'support',
    ORDER_CREATED = 'appcharge_order_created',
    PAYMENT_INTENT_SUCCESS = 'appcharge_payment_intent_success',
    PAYMENT_INTENT_FAILED = 'appcharge_payment_intent_failed',
    ORDER_COMPLETED_SUCCESS = 'appcharge_order_completed_success',
    ORDER_COMPLETED_FAILED = 'appcharge_order_completed_failed',
    CLOSE_CHECKOUT = 'appcharge_close_checkout',
    CHECKOUT_OPENED = 'appcharge_checkout_opened',
    POINTS_ANIMATION_DONE = 'pointsAnimationDone',
    PRODUCTS_ANIMATION_DONE = 'productsAnimationDone',
    REWARD_ANIMATION_DONE = 'rewardAnimationDone',
}

export enum EOrderStatus {
    CREATED = 'created',
    REQUEST_FAILED = 'API request failed',
    PAYMENT_PENDING = 'payment_pending',
    PAYMENT_SUCCEED = 'payment_succeed',
    PAYMENT_FAILED = 'payment_failed',
    CHARGE_PENDING = 'charge_pending',
    CHARGE_SUCCEED = 'charge_succeed',
    CHARGE_FAILED = 'charge_failed',
}

export enum EResultOptions {
    SUCCESS = 'success',
    FAILED = 'failed',
}

export enum EErrorCodes {
    PAYMENT = 'payment',
    AUTH = 'auth',
    STORE_FAILURE = 'storeFailure',
    GIFT_ALREADY_CLAIMED = 'giftAlreadyClaimed',
    DEFAULT = 'default',
}
